<template>
  <navbar
    position="fixed"
    type="primary"
    :color-on-scroll="colorOnScroll"
    menu-classes="ml-auto"
  >
    <template slot-scope="{ toggle, isToggled }">
      <router-link v-popover:popover1 class="navbar-brand" to="/">
        <img class="loyalty-logo" src="../assets/assets_loyalty/assets-19.png">
      </router-link>
    </template>
    <template slot="navbar-menu">
      <li class="nav-item">
        <nav-link to="/">
        <n-button type="info" class="nav-link" round>
            <p>Regresar</p>
        </n-button>
        </nav-link>
      </li>
    </template>
  </navbar>
</template>

<script>
import { DropDown, NavbarToggleButton, Navbar, NavLink, Button} from '@/components';
import { Popover } from 'element-ui';
export default {
  name: 'main-navbar',
  props: {
    transparent: Boolean,
    colorOnScroll: Number
  },
  components: {
    DropDown,
    Navbar,
    NavbarToggleButton,
    NavLink,
    [Popover.name]: Popover,
    [Button.name]: Button
  },
  methods: {
    scrollMeTo(refName) {
      var element = this.$refs[refName];
      var top = element.offsetTop;

      window.scrollTo(0, top);
    }
  }
};
</script>

<style scoped>
.navbar-titles{
  color: black;
  font-weight: bold;
}
.loyalty-logo{
  width: 200px;
}
.welcome{
    color: black;
    margin: 15px;
}
</style>
